import type {
    PurchasableRestrictedSingleSubject,
    RestrictedSingleSubject,
} from '~/Features/StudyPage/Online/Interfaces/RestrictedSingleSubject';

export const IsSubjectPurchasable = (subject: RestrictedSingleSubject): subject is PurchasableRestrictedSingleSubject =>
    subject.canBePurchased && !!subject.price;
